<div class="mt-3 mb-3">{{ title }}</div>

@if (!filteredTemplates.length) {
    <p class="text-light" translate>Reply templates not found</p>
}

@if (!isTextSearchActive && currentFolderName) {
    <div class="mt-3 mb-3">
        <a (click)="openRootFolder()" class="fw-bold" translate>Global</a>
        <span> > </span>
        @if (selectedCategoryWithReplyTemplate.parentData) {
            @for (parent of selectedCategoryWithReplyTemplate.parentData; track parent) {
                <span>
                    <a (click)="showParentCategoryReplyTemplates(parent)">{{ parent.name }}</a> >
                </span>
            }
        }
        {{ currentFolderName }}
    </div>
}

<ul class="list-group">
    @for (template of filteredTemplates; track template) {
        <li class="list-group-item list-group-item-action" (click)="chooseTemplate(template)">
            <div class="d-flex align-items-center justify-content-between pointer w-100">
                <div class="d-flex">
                    @if (template.children.length) {
                        <sb-inline-svg class="icon icon-close me-1" [url]="'/sb-tools/theme/images/folder-icon.svg'">
                        </sb-inline-svg>
                    }
                    <span>
                        @if (isTextSearchActive) {
                            @for (parent of template.parentData; track parent) {
                                <span class="text-light">{{ parent.name }} > </span>
                            }
                        }
                        {{ template.name }}
                    </span>
                </div>

                @if (template.children.length) {
                    <i class="triangle"></i>
                }
            </div>
        </li>
    }
</ul>
